import {supplierDetailsStore} from '@store/suppliers/details/supplier-details.store';
import {getSupplierDetailsDataSource} from '@store/suppliers/details/supplier-details.requests';
import {GlobalStatus} from '@store/common/globalStatus.enum';

export class SupplierDetailsQuery {
  store = supplierDetailsStore;

  supplierDetails$ = getSupplierDetailsDataSource.data$();

  get isArchived() {
    return this.store.getValue().status === GlobalStatus.ARCHIVED;
  }

  get supplierDomain() {
    return this.store.getValue().domains;
  }

  get supplierCurrency() {
    return this.store.getValue().currency;
  }
}

export const supplierDetailsQuery = new SupplierDetailsQuery();
